import { ShapeRenderer } from '@src/slide/application/service/similarity-collection/renderer/shape-renderer';
import {
    ISimilarityCollectionServiceDelegates,
} from '@src/slide/application/service/similarity-collection/similarity-collection-service.interface';
import { IComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-wrapper.interface';

export class MasterShapeRenderer extends ShapeRenderer {
    constructor(
        services: ISimilarityCollectionServiceDelegates,
        renderComponents: IComponentWrapper,
        slideLeft: number,
        slideTop: number,
    ) {
        super(services, renderComponents);

        this.slideLeft = slideLeft;
        this.slideTop = slideTop;
    }
}
